export type TFilePageRenderState =
	| 'empty-processing'
	| 'empty'
	| 'upload-original'
	| 'text-processing'
	| 'only-original'
	| 'first-translation-loading'
	| 'texts'

interface IGetFilePageRenderStateParams {
	noTexts: boolean
	hasAvailableShotlistLanguages: boolean
	hasOriginalContent: boolean
	hasTranslations: boolean
	isProcessingText: boolean
	isTranslateLoading: boolean
}

export const getFilePageRenderState = ({
	noTexts,
	hasAvailableShotlistLanguages,
	hasOriginalContent,
	hasTranslations,
	isProcessingText,
	isTranslateLoading
}: IGetFilePageRenderStateParams): TFilePageRenderState => {
	if (isProcessingText && noTexts) {
		return 'empty-processing'
	}

	if (!hasAvailableShotlistLanguages) {
		return 'empty'
	}

	if (!hasOriginalContent && !hasTranslations) {
		return 'upload-original'
	}

	if (isProcessingText && hasTranslations) {
		return 'text-processing'
	}

	if (hasOriginalContent && !hasTranslations && !isTranslateLoading) {
		return 'only-original'
	}

	if (isTranslateLoading && !hasTranslations) {
		return 'first-translation-loading'
	}

	return 'texts'
}
